import { WifiOff } from 'lucide-react-native';
import { StyleSheet, Text, View } from 'react-native';
import { useTranslation } from '../../contexts/TranslationContext';
import { useNetworkStatus } from '../../hooks/useNetworkStatus';
import { colors } from '../../theme/colors';
import { tokens } from '../../theme/tokens';

export function OfflineBanner() {
  const { isConnected, isInternetReachable } = useNetworkStatus();
  const { t } = useTranslation();

  const isOffline = !isConnected || isInternetReachable === false;

  if (!isOffline) return null;

  return (
    <View style={styles.container} accessibilityRole="alert" accessibilityLiveRegion="assertive">
      <WifiOff color={colors.status.warning.dark} size={16} strokeWidth={2} />
      <Text style={styles.text}>
        {t('common.offline') || 'You are offline. Some features may be unavailable.'}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacing.sm,
    paddingVertical: tokens.spacing.xs,
    paddingHorizontal: tokens.spacing.md,
    backgroundColor: colors.status.warning.bg,
    borderBottomWidth: 1,
    borderBottomColor: colors.status.warning.main,
  },
  text: {
    color: colors.status.warning.light,
    fontSize: 13,
    fontWeight: '500',
  },
});
